export default __webpack_public_path__ + "static/media/Hotel_Card.7092fdc8.svg";